export const INTENTS = {
  referral_request: {
    label: 'Referral ask',
    classes: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300'
  },
  hiring_question: {
    label: 'Hiring question',
    classes: 'bg-violet-50 text-violet-700 dark:bg-violet-900/20 dark:text-violet-300'
  },
  diy_question: {
    label: 'DIY question',
    classes: 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300'
  },
  cost_question: {
    label: 'Cost question',
    classes: 'bg-sky-50 text-sky-700 dark:bg-sky-900/20 dark:text-sky-300'
  },
  complaint: {
    label: 'Complaint',
    classes: 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-300'
  },
  general_discussion: {
    label: 'Discussion',
    classes: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'
  }
}

export const intentMeta = (intent) => INTENTS[intent] || INTENTS.general_discussion
